import { put, call, all, takeEvery, delay } from 'redux-saga/effects'
import { store as reduxStore } from 'index'
import { push } from 'react-router-redux'
import { message } from 'antd'
import {
  listRules as moderationRulesList,
  getRule as getModerationRule,
  listRuleRevisions as moderationRuleRevisionsList,
  deleteRule as moderationRuleDelete,
  updateRule as moderationRuleUpdate,
  listConfiguration as moderationConfigurationList,
  addRule as moderationRuleAdd,
  listKeywords as moderationKeywordsList,
  deleteKeyword as moderationKeywordDelete,
  addKeyword as moderationKeywordAdd,
  updateKeyword as moderationKeywordUpdate,
  getKeyword as moderationKeywordGet,
  listActivities as moderationActivityList,
  listFlaggedMessages as moderationFlaggedMessagesList,
  listReviewedMessages as moderationReviewedMessagesList,
  banSenderOfFlaggedMessage as moderationBanSenderOfFlaggedMessage,
  reviewFlaggedMessage as moderationReviewFlaggedMessage,
  blockFlaggedMessage as moderationBlockFlaggedMessage,
  approveFlaggedMessage as moderationApproveOnlyFlaggedMessage,
  updateBlockedMessageStatus as moderationUpdateBlockedMessageStatus,
  getFlaggedUsersOfMessage,
  getGlobalSettings as moderationGetGlobalSettings,
  updateGlobalSettings as moderationUpdateGlobalSettings,
  addCustomCategory,
  getCustomCategories,
  deleteCustomCategory,
  updateCustomCategory,
} from 'services/moderation'
import _ from 'lodash'
import { objectToParams, getAppHost } from 'helpers'
import actions from './actions'


/* ─── Rules ─────────────────────────────────────────────────────────────────── */

export function* MODERATION_LIST_RULES({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areModerationSectionsLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active

    const rulesPagination = reduxStore.getState().moderation.moderationRulesListPagination
    const { paginationType, pageNo } = payload
    let paginationPayload = ''
    if (paginationType === 'next' && rulesPagination.next !== undefined) {
      paginationPayload = objectToParams(rulesPagination.next)
    } else if (paginationType === 'previous' && rulesPagination.previous !== undefined) {
      paginationPayload = objectToParams(rulesPagination.previous)
    }

    const success = yield call(moderationRulesList, payload.data, paginationPayload)

    if (success && success.data) {
      let totalRuleCount = success.data.length
      let moderationRulesListPagination = {}

      if (success.meta) {
        moderationRulesListPagination = success.meta
        totalRuleCount = success.meta.current.limit + 1
        if (pageNo !== undefined && paginationType === undefined) {
          totalRuleCount = pageNo * success.meta.current.limit
        } else if (
          pageNo !== undefined &&
          paginationType === 'next' &&
          success.meta.next !== undefined
        ) {
          totalRuleCount = pageNo * success.meta.current.limit + 1
        } else if (
          pageNo !== undefined &&
          paginationType === 'previous' &&
          success.meta.previous !== undefined
        ) {
          totalRuleCount = pageNo * success.meta.current.limit + 1
        } else if (
          pageNo === undefined &&
          paginationType === undefined &&
          success.meta.next === undefined
        ) {
          totalRuleCount = pageNo * success.meta.current.limit
        }
      }
      const nonDefaultRules = success.data.filter(item => !item.default)

      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationRulesList: success.data,
          moderationRulesListTotal: totalRuleCount,
          moderationRulesNonDefaultListTotal: nonDefaultRules.length,
          moderationRulesListPagination,
          areModerationSectionsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationRulesList: [],
          moderationRulesListTotal: 0,
          moderationRulesNonDefaultListTotal: 0,
          moderationRulesListPagination: [],
          areModerationSectionsLoading: false,
        },
      })
    }
  } catch (e) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        moderationRulesList: [],
        moderationRulesListTotal: 0,
        moderationRulesNonDefaultListTotal: 0,
        moderationRulesListPagination: [],
        areModerationSectionsLoading: false,
      },
    })
  }
}

export function* MODERATION_GET_RULE({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areModerationSectionsLoading: true,
      },
    })

    const { id, redirectTo } = payload
    if (!payload.data) payload.data = reduxStore.getState().apps.active

    const success = yield call(getModerationRule, id, payload.data)
    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationRuleActive: success.data,
          areModerationSectionsLoading: false,
        },
      })
      if (redirectTo && redirectTo === 'view') {
        const pushObj = {
          pathname: `/app/${payload.data.id}/moderation/rules/${success.data.id}/view`,
        }
        if (payload.from) pushObj.state = { from: payload.from }
        yield put(push(pushObj))
      } else if (redirectTo && redirectTo === 'edit') {
        yield put(push(`/app/${payload.data.id}/moderation/rules/${success.data.id}/edit`))
      }
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationRuleActive: [],
          areModerationSectionsLoading: false,
        },
      })
      yield put(push(`/app/${payload.data.id}/moderation/rules`))
    }
  } catch (e) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        moderationRuleActive: [],
        areModerationSectionsLoading: false,
      },
    })
  }
}

export function* MODERATION_GET_RULE_AND_RULE_REVISIONS({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areModerationSectionsLoading: true,
      },
    })
    const { id, redirectTo } = payload
    if (!payload.data) payload.data = reduxStore.getState().apps.active

    const successRule = yield call(getModerationRule, id, payload.data)
    if (successRule && successRule.data) {
      const ruleRevisionsPagination = reduxStore.getState().moderation.moderationRuleRevisionsList

      const { paginationType, pageNo } = payload
      let paginationPayload = ''
      if (paginationType === 'next' && ruleRevisionsPagination.next !== undefined) {
        paginationPayload = objectToParams(ruleRevisionsPagination.next)
      } else if (paginationType === 'previous' && ruleRevisionsPagination.previous !== undefined) {
        paginationPayload = objectToParams(ruleRevisionsPagination.previous)
      }

      const success = yield call(moderationRuleRevisionsList, id, payload.data, paginationPayload)

      if (success && success.data) {
        let totalRuleRevisionCount = success.data.length
        let moderationRuleRevisionsListPagination = {}

        if (success.meta) {
          moderationRuleRevisionsListPagination = success.meta
          totalRuleRevisionCount = success.meta.current.limit + 1
          if (pageNo !== undefined && paginationType === undefined) {
            totalRuleRevisionCount = pageNo * success.meta.current.limit
          } else if (
            pageNo !== undefined &&
            paginationType === 'next' &&
            success.meta.next !== undefined
          ) {
            totalRuleRevisionCount = pageNo * success.meta.current.limit + 1
          } else if (
            pageNo === undefined &&
            paginationType === undefined &&
            success.meta.next === undefined
          ) {
            totalRuleRevisionCount = pageNo * success.meta.current.limit
          }
        }

        yield put({
          type: actions.SET_STATE,
          payload: {
            moderationRuleRevisionsList: success.data,
            moderationRuleRevisionsListTotal: totalRuleRevisionCount,
            moderationRuleRevisionsListPagination,
            areModerationSectionsLoading: false,
            moderationRuleActive: successRule.data,
          },
        })
        if (redirectTo && redirectTo === 'view') {
          const pushObj = { pathname: `/app/${payload.data.id}/moderation/rules/${id}/view` }
          if (payload.from) pushObj.state = { from: payload.from }
          yield put(push(pushObj))
        }
      } else {
        yield put({
          type: actions.SET_STATE,
          payload: {
            moderationRuleRevisionsList: [],
            moderationRuleRevisionsListTotal: 0,
            moderationRuleRevisionsListPagination: [],
            areModerationSectionsLoading: false,
            moderationRuleActive: successRule.data,
          },
        })
        if (success.error.message !== undefined) {
          window.triggerNotification(success.error.message, 'error')
        }
      }
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationRuleActive: [],
          areModerationSectionsLoading: false,
        },
      })
      if (successRule.error.message !== undefined) {
        window.triggerNotification(successRule.error.message, 'error')
      }
    }
  } catch (e) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        moderationRuleActive: [],
        areModerationSectionsLoading: false,
      },
    })
  }
}

export function* MODERATION_DELETE_RULE({ payload }) {
  try {
    const { id, refresh } = payload
    const activeApp = reduxStore.getState().apps.active
    const { moderationRulesListPagination } = reduxStore.getState().moderation

    const success = yield call(moderationRuleDelete, id, activeApp)

    if (success && success.data) {
      const ruleListPageNo =
        moderationRulesListPagination !== undefined && moderationRulesListPagination.count > 1
          ? moderationRulesListPagination.current_page
          : 1
      yield put({
        type: actions.MODERATION_LIST_RULES,
        payload: { currentPage: ruleListPageNo, data: activeApp },
      })

      window.triggerNotification('Rule deleted', 'success')
      if (refresh) yield put(push(`/app/${activeApp.id}/moderation`))
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      }
  } catch (e) {
    window.triggerNotification('Failed to delete rule', 'error')
  }
}

export function* CHANGE_MODERATION_RULE_STATUS({ payload }) {
  try {
    const { id, status } = payload
    const activeApp = reduxStore.getState().apps.active
    const allRules = reduxStore.getState().moderation.moderationRulesList

    const data = { enabled: !status }
    const success = yield call(moderationRuleUpdate, id, data, activeApp)

    let successMessage

    if (success && success.data) {
      _.forEach(allRules, function fn(c, k) {
        if (c.id === id) {
          if (allRules[k].enabled) {
            successMessage = 'disabled'
          } else {
            successMessage = 'enabled'
          }
          allRules[k].enabled = !allRules[k].enabled
        }
      })

      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationRulesList: allRules,
        },
      })

      window.triggerNotification(`Moderation rule ${successMessage}`, 'success')
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      } else if (success.error.code !== undefined && success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      }
  } catch (e) {
    window.triggerNotification('Failed to update rule status', 'error')
  }
}

export function* MODERATION_ADD_RULE({ payload }) {
  try {
    const activeApp = reduxStore.getState().apps.active
    const success = yield call(moderationRuleAdd, payload, activeApp)

    if (success && success.data) {
      yield put({
        type: actions.MODERATION_LIST_RULES,
        payload: { currentPage: 1, data: activeApp },
      })

      yield put(push(`/app/${activeApp.id}/moderation/rules`))
      window.triggerNotification('Rule added', 'success')
    } else if (success.error && success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
        window.triggerNotification('Plan restriction - Feature not available', 'error')
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
    return success
  } catch (e) {
    window.triggerNotification('Failed to add rule', 'error')
  }
}

export function* MODERATION_UPDATE_RULE({ payload }) {
  try {
    const activeApp = reduxStore.getState().apps.active
    const success = yield call(moderationRuleUpdate, payload.id, payload, activeApp)

    if (success && success.data) {
      yield put({
        type: actions.MODERATION_LIST_RULES,
        payload: { currentPage: 1, data: activeApp },
      })

      yield put(push(`/app/${activeApp.id}/moderation/rules`))
      window.triggerNotification('Rule updated', 'success')
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Unknown Error', 'error')
      }
  } catch (e) {
    window.triggerNotification('Failed to update rule', 'error')
  }
}

export function* MODERATION_LIST_CONFIGURATION({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areModerationSectionsLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active

    const success = yield call(moderationConfigurationList, payload.data)

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationConfigurationList: success.data,
          areModerationSectionsLoading: false,
        },
      })
    } else {
      if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationConfigurationList: [],
          areModerationSectionsLoading: false,
        },
      })
    }
    return success
  } catch (e) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        moderationConfigurationList: [],
        areModerationSectionsLoading: false,
      },
    })
  }
}


/* ─── Keywords ──────────────────────────────────────────────────────────────── */

export function* MODERATION_LIST_KEYWORDS({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areModerationSectionsLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active

    const keywordsPagination = reduxStore.getState().moderation.moderationKeywordListPagination
    const { paginationType, pageNo } = payload
    let paginationPayload = ''
    if (paginationType === 'next' && keywordsPagination.next !== undefined) {
      paginationPayload = objectToParams(keywordsPagination.next)
    } else if (paginationType === 'previous' && keywordsPagination.previous !== undefined) {
      paginationPayload = objectToParams(keywordsPagination.previous)
    }

    const success = yield call(moderationKeywordsList, payload.data, paginationPayload)

    if (success && success.data) {
      let totalKeywordCount = success.data.length
      let moderationKeywordListPagination = {}

      if (success.meta) {
        moderationKeywordListPagination = success.meta
        totalKeywordCount = success.meta.current.limit + 1
        if (pageNo !== undefined && paginationType === undefined) {
          totalKeywordCount = pageNo * success.meta.current.limit
        } else if (
          pageNo !== undefined &&
          paginationType === 'next' &&
          success.meta.next !== undefined
        ) {
          totalKeywordCount = pageNo * success.meta.current.limit + 1
        } else if (
          pageNo === undefined &&
          paginationType === undefined &&
          success.meta.next === undefined
        ) {
          totalKeywordCount = pageNo * success.meta.current.limit
        }
      }

      const nonDefaultkeywords = success.data.filter(item => !item.default)
      const moderationKeywordNonDefaultListTotal = nonDefaultkeywords.length
      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationKeywordsList: success.data,
          moderationKeywordListTotal: totalKeywordCount,
          moderationKeywordNonDefaultListTotal,
          moderationKeywordListPagination,
          areModerationSectionsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationKeywordsList: [],
          moderationKeywordListTotal: 0,
          moderationKeywordNonDefaultListTotal: 0,
          moderationKeywordListPagination: [],
          areModerationSectionsLoading: false,
        },
      })
    }
  } catch (e) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        moderationKeywordsList: [],
        moderationKeywordListTotal: 0,
        moderationKeywordNonDefaultListTotal: 0,
        moderationKeywordListPagination: [],
        areModerationSectionsLoading: false,
      },
    })
  }
}

export function* MODERATION_DELETE_KEYWORD({ payload }) {
  try {
    const { id, refresh } = payload
    const activeApp = reduxStore.getState().apps.active
    const { moderationKeywordListPagination } = reduxStore.getState().moderation

    const success = yield call(moderationKeywordDelete, id, activeApp)

    if (success && success.data) {
      const keywordListPageNo =
        moderationKeywordListPagination !== undefined && moderationKeywordListPagination.count > 1
          ? moderationKeywordListPagination.current_page
          : 1

      yield put({
        type: actions.MODERATION_LIST_KEYWORDS,
        payload: { currentPage: keywordListPageNo, data: activeApp },
      })

      window.triggerNotification('List deleted', 'success')
      if (refresh) yield put(push(`/app/${activeApp.id}/moderation`))
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      } else if (success.error.code !== undefined && success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      }
  } catch (e) {
    window.triggerNotification('Failed to delete keyword list', 'error')
  }
}

export function* MODERATION_ADD_KEYWORD({ payload }) {
  try {
    const activeApp = reduxStore.getState().apps.active
    const success = yield call(moderationKeywordAdd, payload, activeApp)

    if (success && success.data) {
      yield put({
        type: actions.MODERATION_LIST_KEYWORDS,
        payload: { currentPage: 1, data: activeApp },
      })

      yield put(push(`/app/${activeApp.id}/moderation/lists`))
      window.triggerNotification('List added', 'success')
    } else if (success.error && success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
        window.triggerNotification('Plan restriction - Feature not available', 'error')
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
    return success
  } catch (e) {
    window.triggerNotification('Failed to add keyword list', 'error')
  }
}

export function* MODERATION_UPDATE_KEYWORD({ payload }) {
  try {
    const activeApp = reduxStore.getState().apps.active
    const success = yield call(moderationKeywordUpdate, payload.id, payload, activeApp)

    if (success && success.data) {
      yield put({
        type: actions.MODERATION_LIST_KEYWORDS,
        payload: { currentPage: 1, data: activeApp },
      })

      yield put(push(`/app/${activeApp.id}/moderation/lists`))
      window.triggerNotification('List updated', 'success')
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Unknown Error', 'error')
      }
  } catch (e) {
    window.triggerNotification('Failed to update keyword list', 'error')
  }
}

export function* MODERATION_GET_KEYWORD({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areModerationSectionsLoading: true,
      },
    })

    const { id } = payload
    const activeApp = reduxStore.getState().apps.active

    const success = yield call(moderationKeywordGet, id, activeApp)

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationKeywordActive: success.data,
          areModerationSectionsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areModerationSectionsLoading: false,
        },
      })
      if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      }
      yield put(push(`/app/${activeApp.id}/moderation`))
    }
    return success
  } catch (e) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areModerationSectionsLoading: false,
      },
    })
  }
}


/* ─── Messages ──────────────────────────────────────────────────────────────── */

export function* MODERATION_LIST_DROPPED_MESSAGES({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areModerationSectionsLoading: true,
        isModerationActivityLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active

    const activityPagination = reduxStore.getState().moderation.moderationActivityListPagination
    const currentParams =
      reduxStore.getState().moderation.moderationActivityListPaginationCurentParams || {}
    let moderationActivityListPaginationCurentParams = {}

    const { paginationType, pageNo, paginationPayloadCurrent } = payload
    const effectivePageNo =
      pageNo === undefined && paginationType === undefined ? 1 : pageNo

    let paginationPayloadObj = {}
    let paginationPayload = ''

    if (paginationPayloadCurrent !== undefined && paginationPayloadCurrent.affix !== undefined) {
      paginationPayload = objectToParams(paginationPayloadCurrent)
      paginationPayloadObj.affix = paginationPayloadCurrent.affix
    } else if (paginationType === 'next' && activityPagination.next !== undefined) {
      paginationPayload = objectToParams(activityPagination.next)
      paginationPayloadObj = { ...activityPagination.next }
    } else if (paginationType === 'previous' && activityPagination.previous !== undefined) {
      paginationPayload = objectToParams(activityPagination.previous)
      paginationPayloadObj = { ...activityPagination.previous }
    }

    let startRange = 0
    let endRange = 0
    if (
      paginationPayloadCurrent !== undefined &&
      paginationPayloadCurrent.startRange !== undefined
    ) {
      const { startRange: startRangeCurrent, endRange: endRangeCurrent } = paginationPayloadCurrent
      startRange = startRangeCurrent
      endRange = endRangeCurrent
    } else if (
      payload !== undefined &&
      payload.fromDate !== undefined &&
      payload.toDate !== undefined &&
      payload.fromDate &&
      payload.toDate
    ) {
      startRange = payload.fromDate
      endRange = payload.toDate
    } else if (paginationType && currentParams.startRange) {
      ;({ startRange, endRange } = currentParams)
    }

    let filters = {}
    if (payload.filters && Object.keys(payload.filters).length > 0) {
      ;({ filters } = payload)
    } else if (paginationType && currentParams.filters) {
      ;({ filters } = currentParams)
    }

    const { appSettings } = reduxStore.getState().apps

    const success = yield call(
      moderationActivityList,
      payload.data,
      getAppHost(appSettings),
      paginationPayload,
      startRange ? Math.floor(startRange / 1000) : 0,
      endRange ? Math.floor(endRange / 1000) : 0,
      filters,
    )

    if (success && success.data) {
      paginationPayloadObj.startRange = startRange
      paginationPayloadObj.endRange = endRange
      paginationPayloadObj.filters = filters

      moderationActivityListPaginationCurentParams = paginationPayloadObj
      let totalActivityCount = success.data.length
      let moderationActivityListPagination = {}

      if (success.meta) {
        moderationActivityListPagination = success.meta
        totalActivityCount = moderationActivityListPagination.current.limit + 1
        moderationActivityListPaginationCurentParams = paginationPayloadObj

        if (
          effectivePageNo !== undefined &&
          paginationType === undefined &&
          success.meta.next === undefined
        ) {
          totalActivityCount = success.meta.current.count
        } else if (effectivePageNo !== undefined && paginationType === undefined) {
          totalActivityCount = effectivePageNo * success.meta.current.limit + 1
        } else if (
          effectivePageNo !== undefined &&
          paginationType === 'next' &&
          success.meta.next !== undefined
        ) {
          totalActivityCount = effectivePageNo * success.meta.current.limit + 1
        } else if (
          effectivePageNo !== undefined &&
          paginationType === 'previous' &&
          success.meta.previous !== undefined
        ) {
          totalActivityCount = effectivePageNo * success.meta.current.limit + 1
        }
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationActivityList: success.data,
          moderationActivityListTotal: totalActivityCount,
          moderationActivityListPagination,
          areModerationSectionsLoading: false,
          isModerationActivityLoading: false,
          moderationActivityListPaginationCurentParams,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationActivityList: [],
          moderationActivityListTotal: 0,
          moderationActivityListPagination: {},
          areModerationSectionsLoading: false,
          isModerationActivityLoading: false,
          moderationActivityListPaginationCurentParams: {},
        },
      })
    }
    return success
  } catch (e) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        moderationActivityList: [],
        moderationActivityListTotal: 0,
        moderationActivityListPagination: {},
        areModerationSectionsLoading: false,
        isModerationActivityLoading: false,
        moderationActivityListPaginationCurentParams: {},
      },
    })
  }
}

export function* MODERATION_LIST_FLAGGED_MESSAGES({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areModerationSectionsLoading: true,
        isModerationFlaggedMessagesLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active

    const flaggedMessagesPagination =
      reduxStore.getState().moderation.moderationFlaggedMessagesListPagination
    const currentParams =
      reduxStore.getState().moderation.moderationFlaggedMessagesListPaginationCurrentParams || {}
    let moderationFlaggedMessagesListPaginationCurrentParams = {}

    const { paginationType, pageNo, paginationPayloadCurrent } = payload
    const effectivePageNo =
      pageNo === undefined && paginationType === undefined ? 1 : pageNo

    let paginationPayloadObj = {}
    let paginationPayload = ''

    if (paginationPayloadCurrent !== undefined && paginationPayloadCurrent.affix !== undefined) {
      paginationPayload = objectToParams(paginationPayloadCurrent)
      paginationPayloadObj.affix = paginationPayloadCurrent.affix
    } else if (paginationType === 'next' && flaggedMessagesPagination.next !== undefined) {
      paginationPayload = objectToParams(flaggedMessagesPagination.next)
      paginationPayloadObj = { ...flaggedMessagesPagination.next }
    } else if (paginationType === 'previous' && flaggedMessagesPagination.previous !== undefined) {
      paginationPayload = objectToParams(flaggedMessagesPagination.previous)
      paginationPayloadObj = { ...flaggedMessagesPagination.previous }
    }

    let startRange = 0
    let endRange = 0
    if (
      paginationPayloadCurrent !== undefined &&
      paginationPayloadCurrent.startRange !== undefined
    ) {
      const { startRange: startRangeCurrent, endRange: endRangeCurrent } = paginationPayloadCurrent
      startRange = startRangeCurrent
      endRange = endRangeCurrent
    } else if (
      payload !== undefined &&
      payload.fromDate !== undefined &&
      payload.toDate !== undefined &&
      payload.fromDate &&
      payload.toDate
    ) {
      startRange = payload.fromDate
      endRange = payload.toDate
    } else if (paginationType && currentParams.startRange) {
      ;({ startRange, endRange } = currentParams)
    }

    let flaggedFilters = {}
    if (payload.filters && Object.keys(payload.filters).length > 0) {
      flaggedFilters = payload.filters
    } else if (paginationType && currentParams.filters) {
      flaggedFilters = currentParams.filters
    }

    const { appSettings } = reduxStore.getState().apps

    const success = yield call(
      moderationFlaggedMessagesList,
      payload.data,
      getAppHost(appSettings),
      paginationPayload,
      startRange ? Math.floor(startRange / 1000) : 0,
      endRange ? Math.floor(endRange / 1000) : 0,
      flaggedFilters,
    )

    if (success && success.data) {
      moderationFlaggedMessagesListPaginationCurrentParams = paginationPayloadObj
      paginationPayloadObj.startRange = startRange
      paginationPayloadObj.endRange = endRange
      paginationPayloadObj.filters = flaggedFilters
      let totalFlaggedMessagesCount = success.data.length
      let moderationFlaggedMessagesListPagination = {}

      if (success.meta) {
        moderationFlaggedMessagesListPagination = success.meta
        totalFlaggedMessagesCount = moderationFlaggedMessagesListPagination.current.limit + 1
        moderationFlaggedMessagesListPaginationCurrentParams = paginationPayloadObj

        if (
          effectivePageNo !== undefined &&
          paginationType === undefined &&
          success.meta.next === undefined
        ) {
          totalFlaggedMessagesCount = success.meta.current.count
        } else if (effectivePageNo !== undefined && paginationType === undefined) {
          totalFlaggedMessagesCount = effectivePageNo * success.meta.current.limit + 1
        } else if (
          effectivePageNo !== undefined &&
          paginationType === 'next' &&
          success.meta.next !== undefined
        ) {
          totalFlaggedMessagesCount = effectivePageNo * success.meta.current.limit + 1
        } else if (
          effectivePageNo !== undefined &&
          paginationType === 'previous' &&
          success.meta.previous !== undefined
        ) {
          totalFlaggedMessagesCount = effectivePageNo * success.meta.current.limit + 1
        }
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationFlaggedMessagesList: success.data,
          moderationFlaggedMessagesListTotal: totalFlaggedMessagesCount,
          moderationFlaggedMessagesListPagination,
          areModerationSectionsLoading: false,
          isModerationFlaggedMessagesLoading: false,
          moderationFlaggedMessagesListPaginationCurrentParams,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationFlaggedMessagesList: [],
          moderationFlaggedMessagesListTotal: 0,
          moderationFlaggedMessagesListPagination: {},
          areModerationSectionsLoading: false,
          isModerationFlaggedMessagesLoading: false,
          moderationFlaggedMessagesListPaginationCurrentParams: {},
        },
      })
    }
    return success
  } catch (e) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        moderationFlaggedMessagesList: [],
        moderationFlaggedMessagesListTotal: 0,
        moderationFlaggedMessagesListPagination: {},
        areModerationSectionsLoading: false,
        isModerationFlaggedMessagesLoading: false,
        moderationFlaggedMessagesListPaginationCurrentParams: {},
      },
    })
  }
}

export function* MODERATION_LIST_REVIEWED_MESSAGES({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areModerationSectionsLoading: true,
        isModerationReviewedMessagesLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active

    const reviewedMessagesPagination =
      reduxStore.getState().moderation.moderationReviewedMessagesListPagination
    const currentParams =
      reduxStore.getState().moderation.moderationReviewedMessagesListPaginationCurrentParams || {}
    let moderationReviewedMessagesListPaginationCurrentParams = {}

    const { paginationType, pageNo, paginationPayloadCurrent } = payload
    const effectivePageNo =
      pageNo === undefined && paginationType === undefined ? 1 : pageNo

    let paginationPayloadObj = {}
    let paginationPayload = ''

    if (paginationPayloadCurrent !== undefined && paginationPayloadCurrent.affix !== undefined) {
      paginationPayload = objectToParams(paginationPayloadCurrent)
      paginationPayloadObj.affix = paginationPayloadCurrent.affix
    } else if (paginationType === 'next' && reviewedMessagesPagination.next !== undefined) {
      paginationPayload = objectToParams(reviewedMessagesPagination.next)
      paginationPayloadObj = { ...reviewedMessagesPagination.next }
    } else if (paginationType === 'previous' && reviewedMessagesPagination.previous !== undefined) {
      paginationPayload = objectToParams(reviewedMessagesPagination.previous)
      paginationPayloadObj = { ...reviewedMessagesPagination.previous }
    }

    let startRange = 0
    let endRange = 0
    if (
      paginationPayloadCurrent !== undefined &&
      paginationPayloadCurrent.startRange !== undefined
    ) {
      const { startRange: startRangeCurrent, endRange: endRangeCurrent } = paginationPayloadCurrent
      startRange = startRangeCurrent
      endRange = endRangeCurrent
    } else if (
      payload !== undefined &&
      payload.fromDate !== undefined &&
      payload.toDate !== undefined &&
      payload.fromDate &&
      payload.toDate
    ) {
      startRange = payload.fromDate
      endRange = payload.toDate
    } else if (paginationType && currentParams.startRange) {
      ;({ startRange, endRange } = currentParams)
    }

    let reviewedFilters = {}
    if (payload.filters && Object.keys(payload.filters).length > 0) {
      reviewedFilters = payload.filters
    } else if (paginationType && currentParams.filters) {
      reviewedFilters = currentParams.filters
    }

    const { appSettings } = reduxStore.getState().apps

    const success = yield call(
      moderationReviewedMessagesList,
      payload.data,
      getAppHost(appSettings),
      paginationPayload,
      startRange ? Math.floor(startRange / 1000) : 0,
      endRange ? Math.floor(endRange / 1000) : 0,
      reviewedFilters,
    )

    if (success && success.data) {
      moderationReviewedMessagesListPaginationCurrentParams = paginationPayloadObj
      paginationPayloadObj.startRange = startRange
      paginationPayloadObj.endRange = endRange
      paginationPayloadObj.filters = reviewedFilters
      let totalReviewedMessagesCount = success.data.length
      let moderationReviewedMessagesListPagination = {}

      if (success.meta) {
        moderationReviewedMessagesListPagination = success.meta
        totalReviewedMessagesCount = moderationReviewedMessagesListPagination.current.limit + 1
        moderationReviewedMessagesListPaginationCurrentParams = paginationPayloadObj

        if (
          effectivePageNo !== undefined &&
          paginationType === undefined &&
          success.meta.next === undefined
        ) {
          totalReviewedMessagesCount = success.meta.current.count
        } else if (effectivePageNo !== undefined && paginationType === undefined) {
          totalReviewedMessagesCount = effectivePageNo * success.meta.current.limit + 1
        } else if (
          effectivePageNo !== undefined &&
          paginationType === 'next' &&
          success.meta.next !== undefined
        ) {
          totalReviewedMessagesCount = effectivePageNo * success.meta.current.limit + 1
        } else if (
          effectivePageNo !== undefined &&
          paginationType === 'previous' &&
          success.meta.previous !== undefined
        ) {
          totalReviewedMessagesCount = effectivePageNo * success.meta.current.limit + 1
        }
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationReviewedMessagesList: Array.isArray(success.data) ? success.data : [],
          moderationReviewedMessagesListTotal: totalReviewedMessagesCount,
          moderationReviewedMessagesListPagination,
          areModerationSectionsLoading: false,
          isModerationReviewedMessagesLoading: false,
          moderationReviewedMessagesListPaginationCurrentParams,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationReviewedMessagesList: [],
          moderationReviewedMessagesListTotal: 0,
          moderationReviewedMessagesListPagination: {},
          areModerationSectionsLoading: false,
          isModerationReviewedMessagesLoading: false,
          moderationReviewedMessagesListPaginationCurrentParams: {},
        },
      })
    }

    return success
  } catch (e) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        moderationReviewedMessagesList: [],
        moderationReviewedMessagesListTotal: 0,
        moderationReviewedMessagesListPagination: {},
        areModerationSectionsLoading: false,
        isModerationReviewedMessagesLoading: false,
        moderationReviewedMessagesListPaginationCurrentParams: {},
      },
    })
  }
}

export function* MODERATION_ACCEPT_FLAGGED_MESSAGE({ payload }) {
  try {
    const { id } = payload
    const activeApp = reduxStore.getState().apps.active

    const success = yield call(moderationReviewFlaggedMessage, activeApp, id)
    if (success && !success.error) {
      window.triggerNotification('Message approved & marked reviewed', 'success')
      yield delay(750)
      const cacheBust = { paginationPayloadCurrent: { ts: Date.now() } }
      yield put({
        type: actions.MODERATION_LIST_FLAGGED_MESSAGES,
        payload: { data: activeApp, ...cacheBust },
      })
      yield put({
        type: actions.MODERATION_LIST_REVIEWED_MESSAGES,
        payload: { data: activeApp, ...cacheBust },
      })
    } else {
      const errMsg = success?.error?.message || 'Failed to review message'
      window.triggerNotification(errMsg, 'error')
    }
  } catch (e) {
    window.triggerNotification('Failed to review message', 'error')
  }
}

export function* MODERATION_APPROVE_FLAGGED_MESSAGE({ payload }) {
  try {
    const { id, fromDate, toDate } = payload
    const activeApp = reduxStore.getState().apps.active

    const success = yield call(moderationApproveOnlyFlaggedMessage, activeApp, id)
    if (success && !success.error) {
      window.triggerNotification('Message approved', 'success')
      yield delay(750)
      const cacheBust = { paginationPayloadCurrent: { ts: Date.now() } }
      yield put({
        type: actions.MODERATION_LIST_FLAGGED_MESSAGES,
        payload: {
          data: activeApp,
          ...cacheBust,
          ...(fromDate && toDate ? { fromDate, toDate } : {}),
        },
      })
    } else {
      const errMsg = success?.error?.message || 'Failed to approve message'
      window.triggerNotification(errMsg, 'error')
    }
  } catch (e) {
    window.triggerNotification('Failed to approve message', 'error')
  }
}

export function* MODERATION_BLOCK_FLAGGED_MESSAGE({ payload }) {
  try {
    const { id, fromDate, toDate } = payload
    const activeApp = reduxStore.getState().apps.active

    const success = yield call(moderationBlockFlaggedMessage, activeApp, id)
    if (success && !success.error) {
      window.triggerNotification('Message blocked', 'success')
      yield delay(750)
      const cacheBust = { paginationPayloadCurrent: { ts: Date.now() } }
      yield put({
        type: actions.MODERATION_LIST_FLAGGED_MESSAGES,
        payload: {
          data: activeApp,
          ...cacheBust,
          ...(fromDate && toDate ? { fromDate, toDate } : {}),
        },
      })
      yield put({
        type: actions.MODERATION_LIST_DROPPED_MESSAGES,
        payload: { data: activeApp, ...cacheBust },
      })
    } else {
      const errMsg = success?.error?.message || 'Failed to block message'
      window.triggerNotification(errMsg, 'error')
    }
  } catch (e) {
    window.triggerNotification('Failed to block message', 'error')
  }
}

export function* MODERATION_BAN_FLAGGED_MESSAGE_SENDER({ payload }) {
  try {
    const { id } = payload
    const activeApp = reduxStore.getState().apps.active

    const success = yield call(moderationBanSenderOfFlaggedMessage, activeApp, id)
    if (success && success.data) {
      window.triggerNotification('Sender banned successfully', 'success')
      yield put({ type: actions.MODERATION_LIST_FLAGGED_MESSAGES, payload: { data: activeApp } })
    } else {
      window.triggerNotification('Failed to ban sender', 'error')
    }
  } catch (e) {
    window.triggerNotification('Failed to ban sender', 'error')
  }
}

export function* MODERATION_UPDATE_BLOCKED_MESSAGE_STATUS({ payload }) {
  try {
    const { id, status, reviewed, refresh, fromDate, toDate } = payload
    const activeApp = reduxStore.getState().apps.active

    const success = yield call(
      moderationUpdateBlockedMessageStatus,
      id,
      status,
      activeApp,
      reviewed,
    )

    if (success && success.data) {
      const { moderationActivityListPagination } =
        reduxStore.getState().moderation
      const blockedMessageListPageNo =
        moderationActivityListPagination !== undefined &&
        moderationActivityListPagination.count > 1
          ? moderationActivityListPagination.current_page
          : 1

      const { moderationActivityListPaginationCurentParams } =
        reduxStore.getState().moderation

      yield put({
        type: actions.MODERATION_LIST_DROPPED_MESSAGES,
        payload: {
          pageNo: blockedMessageListPageNo,
          paginationPayloadCurrent: moderationActivityListPaginationCurentParams,
          data: activeApp,
          ...(fromDate && toDate ? { fromDate, toDate } : {}),
        },
      })

      window.triggerNotification(
        success.data.message,
        success.data.success ? 'success' : 'warning',
      )
      if (refresh) yield put(push(`/app/${activeApp.id}/moderation`))
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      }
  } catch (e) {
    window.triggerNotification('Failed to update blocked message status', 'error')
  }
}

export function* GET_FLAGGEDBY_USERS({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        isFlaggedByUsersLoading: true,
      },
    })

    if (!payload.data) payload.data = reduxStore.getState().apps.active

    const { paginationType, pageNo, messageID } = payload

    const logsPagination = reduxStore.getState().moderation.flaggedByUsersPagination

    let paginationPayload = ''
    if (paginationType === 'next' && logsPagination && logsPagination.next !== undefined) {
      paginationPayload = objectToParams(logsPagination.next)
    } else if (
      paginationType === 'previous' &&
      logsPagination &&
      logsPagination.previous !== undefined
    ) {
      paginationPayload = objectToParams(logsPagination.previous)
    }

    const success = yield call(getFlaggedUsersOfMessage, payload.data, messageID, paginationPayload)

    if (success && success.data) {
      let totalLogCount = success.data.length
      let flaggedByUsersPagination = {}

      if (success.meta) {
        flaggedByUsersPagination = success.meta
        totalLogCount = success.meta.current.limit + 1

        if (pageNo !== undefined && paginationType === undefined && !success.meta?.next?.affix) {
          totalLogCount = pageNo * success.meta.current.limit
        } else if (
          pageNo !== undefined &&
          paginationType === undefined &&
          success.meta?.next?.affix === 'append'
        ) {
          totalLogCount = success.meta.current.limit + 1
        } else if (
          pageNo !== undefined &&
          paginationType === 'next' &&
          success.meta?.next?.affix !== undefined
        ) {
          totalLogCount = pageNo * success.meta.current.limit + 1
        } else if (
          pageNo !== undefined &&
          paginationType === 'previous' &&
          success.meta?.previous?.affix !== undefined
        ) {
          totalLogCount = pageNo * success.meta.current.limit + 1
        } else if (
          pageNo === undefined &&
          paginationType === undefined &&
          success.meta.next === undefined
        ) {
          totalLogCount = pageNo * success.meta.current.limit
        }
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          flaggedByUsers: success.data,
          flaggedByUsersTotal: totalLogCount,
          flaggedByUsersPagination,
          isFlaggedByUsersLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          flaggedByUsers: [],
          flaggedByUsersTotal: 0,
          flaggedByUsersPagination: {},
          isFlaggedByUsersLoading: false,
        },
      })
    }
  } catch (e) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        flaggedByUsers: [],
        flaggedByUsersTotal: 0,
        flaggedByUsersPagination: {},
        isFlaggedByUsersLoading: false,
      },
    })
  }
}


/* ─── Settings ──────────────────────────────────────────────────────────────── */

export function* UPDATE_MODERATION_GLOBAL_SETTINGS({ payload }) {
  try {
    const activeApp = reduxStore.getState().apps.active
    const { updatedSettings, isCustomApi } = payload

    const success = yield call(moderationUpdateGlobalSettings, activeApp, updatedSettings)

    if (success && success.data) {
      yield put({
        type: actions.GET_MODERATION_GLOBAL_SETTINGS,
        payload: { payload },
      })

      window.triggerNotification(
        isCustomApi ? 'Custom API settings saved' : 'OpenAI settings saved',
        'success',
      )
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
        message.error(success.error.message)
      } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
        window.triggerNotification('Plan restriction - Feature not available', 'error')
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
    return success
  } catch (e) {
    window.triggerNotification('Failed to update moderation settings', 'error')
  }
}

export function* GET_MODERATION_GLOBAL_SETTINGS({ payload }) {
  try {
    if (!payload.data) payload.data = reduxStore.getState().apps.active

    const success = yield call(moderationGetGlobalSettings, payload.data)
    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          moderationOpenAICustomAPISettings: success.data,
        },
      })
    } else {
      yield put(push(`/app/${payload.data.id}/moderation/rules`))
    }
  } catch (e) {
    window.triggerNotification('Failed to fetch moderation settings', 'error')
  }
}

/* ─── Categories ────────────────────────────────────────────────────────────── */

export function* ADD_CUSTOM_CATEGORY({ payload }) {
  try {
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const filtered = {}
    _.filter(payload, function fn(n, k) {
      if (payload[k] && _.trim(payload[k]) !== '') {
        filtered[k] = n
      }
    })

    const success = yield call(addCustomCategory, filtered, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.FETCH_CUSTOM_CATEGORIES,
        payload: {
          data: activeApp,
          appSettings,
        },
      })
      window.triggerNotification('Custom category added', 'success')
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
    return success
  } catch (e) {
    window.triggerNotification('Failed to add custom category', 'error')
  }
}

export function* FETCH_CUSTOM_CATEGORIES({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        isCustomCategoriesLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(getCustomCategories, payload.data, getAppHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          customCategoriesList: success.data,
          isCustomCategoriesLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          customCategoriesList: [],
          isCustomCategoriesLoading: false,
        },
      })
    }
  } catch (e) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        customCategoriesList: [],
        isCustomCategoriesLoading: false,
      },
    })
  }
}

export function* DELETE_CUSTOM_CATEGORY({ payload }) {
  try {
    const { id } = payload
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(deleteCustomCategory, id, activeApp, getAppHost(appSettings))

    if (success.success) {
      yield put({
        type: actions.FETCH_CUSTOM_CATEGORIES,
        payload: {
          data: activeApp,
          appSettings,
        },
      })
      window.triggerNotification(success.message, 'success')
    } else if (success.error?.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error?.details?.name, 'error')
      }
  } catch (e) {
    window.triggerNotification('Failed to delete custom category', 'error')
  }
}

export function* UPDATE_CUSTOM_CATEGORY({ id, payload }) {
  try {
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const filtered = {}
    const unset = []

    _.filter(payload, function fn(n, k) {
      if (k === 'description') {
        filtered[k] = n || ''
      } else if (payload[k] && _.trim(payload[k]) !== '') {
        filtered[k] = n
      } else if (k === 'tags') {
        filtered.tags = []
      } else unset.push(k)
    })

    filtered.unset = unset

    const success = yield call(
      updateCustomCategory,
      id,
      filtered,
      activeApp,
      getAppHost(appSettings),
    )

    if (success && success.data) {
      yield put({
        type: actions.FETCH_CUSTOM_CATEGORIES,
        payload: { data: activeApp, appSettings },
      })
      window.triggerNotification('Custom category updated', 'success')
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
  } catch (e) {
    window.triggerNotification('Failed to update custom category', 'error')
  }
}

/* ─── Root Saga ─────────────────────────────────────────────────────────────── */

export default function* moderationSaga() {
  yield all([
    takeEvery(actions.MODERATION_LIST_RULES, MODERATION_LIST_RULES),
    takeEvery(actions.MODERATION_GET_RULE, MODERATION_GET_RULE),
    takeEvery(actions.MODERATION_GET_RULE_AND_RULE_REVISIONS, MODERATION_GET_RULE_AND_RULE_REVISIONS),
    takeEvery(actions.MODERATION_DELETE_RULE, MODERATION_DELETE_RULE),
    takeEvery(actions.CHANGE_MODERATION_RULE_STATUS, CHANGE_MODERATION_RULE_STATUS),
    takeEvery(actions.MODERATION_ADD_RULE, MODERATION_ADD_RULE),
    takeEvery(actions.MODERATION_UPDATE_RULE, MODERATION_UPDATE_RULE),
    takeEvery(actions.MODERATION_LIST_CONFIGURATION, MODERATION_LIST_CONFIGURATION),
    takeEvery(actions.MODERATION_LIST_KEYWORDS, MODERATION_LIST_KEYWORDS),
    takeEvery(actions.MODERATION_DELETE_KEYWORD, MODERATION_DELETE_KEYWORD),
    takeEvery(actions.MODERATION_ADD_KEYWORD, MODERATION_ADD_KEYWORD),
    takeEvery(actions.MODERATION_UPDATE_KEYWORD, MODERATION_UPDATE_KEYWORD),
    takeEvery(actions.MODERATION_GET_KEYWORD, MODERATION_GET_KEYWORD),
    takeEvery(actions.MODERATION_LIST_DROPPED_MESSAGES, MODERATION_LIST_DROPPED_MESSAGES),
    takeEvery(actions.MODERATION_LIST_FLAGGED_MESSAGES, MODERATION_LIST_FLAGGED_MESSAGES),
    takeEvery(actions.MODERATION_LIST_REVIEWED_MESSAGES, MODERATION_LIST_REVIEWED_MESSAGES),
    takeEvery(actions.MODERATION_ACCEPT_FLAGGED_MESSAGE, MODERATION_ACCEPT_FLAGGED_MESSAGE),
    takeEvery(actions.MODERATION_APPROVE_FLAGGED_MESSAGE, MODERATION_APPROVE_FLAGGED_MESSAGE),
    takeEvery(actions.MODERATION_BLOCK_FLAGGED_MESSAGE, MODERATION_BLOCK_FLAGGED_MESSAGE),
    takeEvery(actions.MODERATION_BAN_FLAGGED_MESSAGE_SENDER, MODERATION_BAN_FLAGGED_MESSAGE_SENDER),
    takeEvery(actions.MODERATION_UPDATE_BLOCKED_MESSAGE_STATUS, MODERATION_UPDATE_BLOCKED_MESSAGE_STATUS),
    takeEvery(actions.GET_FLAGGEDBY_USERS, GET_FLAGGEDBY_USERS),
    takeEvery(actions.UPDATE_MODERATION_GLOBAL_SETTINGS, UPDATE_MODERATION_GLOBAL_SETTINGS),
    takeEvery(actions.GET_MODERATION_GLOBAL_SETTINGS, GET_MODERATION_GLOBAL_SETTINGS),
    takeEvery(actions.ADD_CUSTOM_CATEGORY, ADD_CUSTOM_CATEGORY),
    takeEvery(actions.FETCH_CUSTOM_CATEGORIES, FETCH_CUSTOM_CATEGORIES),
    takeEvery(actions.DELETE_CUSTOM_CATEGORY, DELETE_CUSTOM_CATEGORY),
    takeEvery(actions.UPDATE_CUSTOM_CATEGORY, UPDATE_CUSTOM_CATEGORY),
  ])
}
